import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Input } from '@THC/components/Input';
import { TickIcon } from '../Icons';
import styles from './InputVRM.module.scss';
const InputVRMBase = forwardRef(({ className, ...rest }, ref) => (<input className={cx(className, styles.inputVRM)} {...rest} ref={ref}/>));
export const InputVRM = (props) => {
    const { formProps, ...rest } = props;
    const { autoCapitalize = 'characters', autoComplete = 'off', maxLength = 10, placeholder = 'Enter reg', ...restFormProps } = formProps || {};
    const intentIcon = rest.intent === 'success' ? (iconProps) => <TickIcon {...iconProps} size="small"/> : undefined;
    return (<Input {...rest} __internal={{
            rootClassName: styles.inputVRMWrapper,
        }} append={rest.append || intentIcon} as={InputVRMBase} data-input-type="vrm" data-intent={rest.intent} formProps={{
            autoCapitalize,
            autoComplete,
            maxLength,
            placeholder,
            ...restFormProps,
        }} prepend={rest.prepend || intentIcon}/>);
};
